import { type App, reactive, readonly } from 'vue';

// Import the global options.
import { preconUserProfilesOptionsInjectionKey } from './symbols';
import {
    type PreconUserProfilesGlobalOptions,
    normalizePreconUserProfilesOptions,
} from './options';

// Export the
export type { PreconUserProfilesGlobalOptions };

// Export the helpers that you want to use outside of this library.
export {
    normalizeUserName,
    type NormalizedUserName,
} from './helpers/normalizeUserName';

// Export the composables that you want to use outside of this library.
export { useNormalizedUserName } from './composables/useNormalizedUserName';

// Import/Export the components that you want to use outside of this library.
import UserAvatar from './components/UserAvatar.vue';
import UserAccountSummary from './components/UserAccountSummary.vue';
import CurrentTeamSelector from './components/CurrentTeamSelector.vue';
import RoleBadge from './components/RoleBadge.vue';

export { UserAvatar, RoleBadge, UserAccountSummary, CurrentTeamSelector };

// The definition of the plugin that installs the
export default {
    install(app: App, options?: PreconUserProfilesGlobalOptions) {
        /// NORMALIZE THE OPTIONS
        const normalizedOptions = reactive(
            normalizePreconUserProfilesOptions(options ?? {})
        );

        /// INJECT THE OPTIONS
        // This ensures that the options are available to the components in this library.
        app.provide(
            preconUserProfilesOptionsInjectionKey,
            readonly(normalizedOptions)
        );

        /// GLOBAL COMPONENT BINDINGS
        // Use this to register the components that you use almost everywhere in the application.
        // WARNING! Do not register large components like this, as it introduces a significant overhead at the application startup.
        app.component('UserAvatar', UserAvatar);
        app.component('RoleBadge', RoleBadge);
    },
};
